import React, { useState } from "react";
import "./TeamSection.css";
import { motion } from "framer-motion";
import { FaLinkedin, FaEnvelope, FaQuoteLeft } from "react-icons/fa";

const TeamSection = () => {
  const [selectedMember, setSelectedMember] = useState(null);

  const teamMembers = [
    {
      name: "Subrat Tripathy",
      role: "MD & FOUNDER",
      education: [
        "Alumni- ISB",
        "(Advance Management in Public Policy)",
        "Alumni- KIIT",
      ],
      image: "images/team1.png",
      quote: "Leading innovation in fleet management across India",
      linkedin: "https://linkedin.com/in/subrat-tripathy",
      email: "subrat@company.com",
    },
    {
      name: "Anshuman-Mohapatra",
      role: "CEO",
      education: ["Alumni- KIT"],
      image: "images/anshuman-mohapatra.jpeg",
    },
 
    {
      name: "Siddhartha Tiwari",
      role: "ADVISOR",
      education: ["Alumni- IIT KGP"],
      image: "images/team2.png",
    },
    {
      name: "Itishree Sahoo",
      role: "Lead - Customer Success & Operations",
      education: ["Alumni- UU", "(M.tech, CSE)"],
      image: "images/Itishree.jpg",
    },

    {
      name: "Rashmi Satapathy",
      role: "COMPANY SECRETARY",
      education: ["Professional Consultant"],
      image: "images/team3.png",
    },

  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const memberVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100,
      },
    },
  };

  return (
    <motion.div
      className="team-section"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      variants={containerVariants}
    >
      <motion.div
        className="team-header"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <div className="header-content">
          <h2 className="team-title">
            <span className="our-team">Our Team</span>
          </h2>
          <p className="team-subtitle">The Visionaries Behind Our Success</p>
        </div>
      </motion.div>

      <motion.div className="team-grid" variants={containerVariants}>
        {teamMembers.map((member, index) => (
          <motion.div
            key={member.name}
            className="team-member-card"
            variants={memberVariants}
            whileHover={{ y: -10 }}
            onClick={() => setSelectedMember(member)}
          >
            <div className="member-image-container">
              <img
                src={member.image}
                alt={member.name}
                className="member-image"
              />
              <div className="member-overlay">
                <div className="social-links">
                  <a
                    href={member.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaLinkedin className="social-icon" />
                  </a>
                  <a href={`mailto:${member.email}`}>
                    <FaEnvelope className="social-icon" />
                  </a>
                </div>
              </div>
            </div>
            <div className="member-info">
              <h3 className="member-name">{member.name}</h3>
              <p className="member-role">{member.role}</p>
              <div className="member-education">
                {member.education.map((edu, eduIndex) => (
                  <span key={eduIndex} className="education-tag">
                    {edu}
                  </span>
                ))}
              </div>
            </div>
          </motion.div>
        ))}
      </motion.div>

      {selectedMember && (
        <motion.div
          className="member-modal-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={() => setSelectedMember(null)}
        >
          <motion.div
            className="member-modal"
            initial={{ scale: 0.5, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.5, opacity: 0 }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="close-button"
              onClick={() => setSelectedMember(null)}
            >
              ×
            </button>
            <div className="modal-content">
              <div className="modal-image">
                <img src={selectedMember.image} alt={selectedMember.name} />
              </div>
              <div className="modal-info">
                <h2>{selectedMember.name}</h2>
                <p className="modal-role">{selectedMember.role}</p>
                <div className="modal-quote">
                  <FaQuoteLeft className="quote-icon" />
                  <p>{selectedMember.quote}</p>
                </div>
                <div className="modal-education">
                  <h3>Education</h3>
                  {selectedMember.education.map((edu, index) => (
                    <p key={index}>{edu}</p>
                  ))}
                </div>
                <div className="modal-social">
                  <a
                    href={selectedMember.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaLinkedin /> Connect on LinkedIn
                  </a>
                  <a href={`mailto:${selectedMember.email}`}>
                    <FaEnvelope /> Send Email
                  </a>
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </motion.div>
  );
};

export default TeamSection;
